import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  OnInit,
} from '@angular/core';
import { HorizontalProductV2Component } from '@epicuro-next/ataraxia/horizontal-product-card';
import { LoaderOverlayModule } from '@epicuro-next/ataraxia/loader-overlay';
import { Product } from 'graphql-api/gql-api-interfaces';

import { SimilarProductsStore } from '../../services/similar-products.component.store';

@Component({
  selector: 'epc-similar-products-container',
  imports: [CommonModule, LoaderOverlayModule, HorizontalProductV2Component],
  templateUrl: './similar-products-container.component.html',
  styleUrl: './similar-products-container.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SimilarProductsContainerComponent implements OnInit {
  // provide in parent SimilarProductsStore, SuggestService to allow SimilarProductsStore cashes response
  private readonly similarProductsStore = inject(SimilarProductsStore);
  public readonly productId = input<string>('');
  public readonly brandId = input<string>('');

  public readonly hasError = this.similarProductsStore.hasError;
  public readonly isLoading = this.similarProductsStore.isLoading;
  public readonly isLoaded = this.similarProductsStore.isLoaded;
  public readonly products = this.similarProductsStore.items;

  public ngOnInit() {
    this.similarProductsStore.loadSimilarProducts({
      productId: this.productId(),
      brandId: this.brandId(),
    });
  }

  public onProductClick(product: Product) {
    this.similarProductsStore.handleProductClick(product);
  }
}
